import _ from "lodash";

// vue
import Vue from "vue";
import { mapGetters } from "vuex";

// Icons
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// services
import { ObjectUtil, PartListService, QuickOrderService } from "@/services";

// components
import { LoadingSpinner } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";
import { default as PartListing } from "../PartListing.vue";

// types
import { IGridListRowItem } from "@/components/Elements/PartsListGrid/PartsListGrid";
import { IQuickOrdersContext } from "../../QuickOrders.types";

export default Vue.extend({
  name: "AddToListDialog",
  mixins: [inputValidateState],
  components: {
    FontAwesomeIcon,
    LoadingSpinner,
    PartListing,
  },
  computed: {
    ...mapGetters(["getContentItem", "partsLists"]),
  },
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IQuickOrdersContext>(),
    },
    items: {
      type: Array,
      default: () => [] as IGridListRowItem[],
    },
  },
  data: () => ({
    errorIcon: faExclamationTriangle,

    isBusy: 0,
    invalidFormMessage: "",

    // form fields
    newListId: 0,
    newListName: ""
  }),
  created() {
    if (!this.partList) {
      this.loadPartList();
    }
  },
  methods: {
    async loadPartList() {
      try {
        this.isBusy++;

        const context = this.context as IQuickOrdersContext;

        const request = {
          accountId: context.accountId,
          userId: context.user.UserId,
          numberItemsToReturn: 10
        };

        const partsList = await PartListService.GetPartListSummary(request);

        this.$store.commit("SET_PARTS_LISTS", partsList);
      } finally {
        this.isBusy--;
      }
    },

    async submitPartListForm() {
      this.$emit("on-parts-adding");

      const context = this.context as IQuickOrdersContext;
      const items = this.items as IGridListRowItem[];

      if (this.newListId === 0 && !_.trim(this.newListName)) {
        this.invalidFormMessage = this.getContentItem("RenamePartListMessage");
        return;
      }

      const rq = {
        accountId: context.accountId,
        userId: context.user.UserId,
        sourceListId: Number(context.partListId),
        sourceItemIds: items.filter((x) => x.Selected).map((x) => x.Id),
        removeImportedItemsFromSource: false,
        newListId: this.newListId,
        newListName: this.newListName,
      };

      try {
        const result = await QuickOrderService.addItemsToList(rq);

        this.$emit("on-parts-added", result);
      } catch (err) {
        this.$emit("on-error", err);
      }
    },

    clearValidationMessage() {
      this.invalidFormMessage = "";
    },

    cancel() {
      this.$emit("on-cancel");
    },
  },
});
